<template>
  <product-infowrap :product="product" :fields="fields" :title="_('Properties')" :baseDomain="baseDomain" :shopId="shopId"></product-infowrap>
</template>

<script>
import ProductInfowrap from '~/components/ProductInfowrap.vue'

export default {
  data () {
    return {
      fields: [
        'facilities',
        'featuredescription',
        'entertainmentproperties',
        'kitchenproperties',
        'numberofkitchensets',
        'kitcheninformation',
        'yardproperties',
        'yarddescription',
        'shoretype',
        'shoredescription',
        'carproperties',
        'accessibilityproperties',
        'activityproperties',
        'activitiesdescription',
        'restrictions'
      ]
    }
  },
  props: ['product', 'baseDomain', 'shopId', 'hideImage'],
  components: {
    ProductInfowrap
  }
}
</script>
